export function initfeaturedTabs() {
	const tabsContainer = document.querySelector(".act-featured-tabs");
	  if (!tabsContainer) return;

	  const tabs = Array.from(tabsContainer.querySelectorAll(".tab"));
	  const tabNames = Array.from(tabsContainer.querySelectorAll(".tab-name"));

	  // Utility: slugify visible tab names (e.g., "Expo Hall" -> "expo-hall")
	  const slug = (s) => s
	    .toLowerCase()
	    .trim()
	    .replace(/&/g, "and")
	    .replace(/[^a-z0-9]+/g, "-")
	    .replace(/^-+|-+$/g, "");

	  // Ensure each .tab has a data-tab (if author didn't provide one)
	  tabs.forEach(tab => {
	    if (!tab.dataset.tab) {
	      const nameEl = tab.querySelector(".tab-name");
	      if (nameEl) tab.dataset.tab = slug(nameEl.textContent || nameEl.innerText || "");
	    }
	  });

	  // Activate helper
	  const setActiveTab = (tab, { updateURL = true, scroll = false } = {}) => {
	    if (!tab || tab.classList.contains("active")) return;

	    tabs.forEach(t => t.classList.remove("active"));
	    tab.classList.add("active");

	    if (updateURL) {
	      const url = new URL(window.location.href);
	      url.searchParams.set("feature-tab", tab.dataset.tab || "");
	      history.replaceState(null, "", url.toString());
	    }

	    if (scroll) {
	      tabsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
	    }
	  };

	  // Click handlers (also keep the URL in sync)
	  tabNames.forEach(tabName => {
	    tabName.addEventListener("click", function () {
	      const tab = this.closest(".tab");
	      if (!tab) return;
	      setActiveTab(tab, { updateURL: true, scroll: false });
	    });
	  });

	  // Try to find a tab from URL parameters
	  const findTabFromURL = () => {
	    const url = new URL(window.location.href);
	    const params = url.searchParams;

	    // 1) Preferred: ?tab=<value> matches data-tab
	    const tabParam = params.get("feature-tab");
	    if (tabParam) {
	      const byDataTab = tabs.find(t => (t.dataset.tab || "") === tabParam);
	      if (byDataTab) return byDataTab;

	      // Fallback: match slug of .tab-name
	      const bySluggedName = tabs.find(t => {
	        const name = t.querySelector(".tab-name");
	        return name && slug(name.textContent || name.innerText || "") === tabParam;
	      });
	      if (bySluggedName) return bySluggedName;
	    }

	    // 2) Generic: if any param matches a data-* on the tab (name or value)
	    for (const [key, value] of params.entries()) {
	      // Match data-<key>=<value>
	      const byKeyValue = tabs.find(t => t.dataset && t.dataset[key] && (!value || t.dataset[key] === value));
	      if (byKeyValue) return byKeyValue;

	      // Or param value matches data-tab
	      const byValue = tabs.find(t => (t.dataset.tab || "") === value);
	      if (byValue) return byValue;
	    }

	    return null; // nothing matched; keep default
	  };

	  // On load: if URL points to a tab, activate it and scroll
	  const tabFromURL = findTabFromURL();
	  if (tabFromURL) {
	    setActiveTab(tabFromURL, { updateURL: false, scroll: true });
	  }
}